import { useQuery } from 'react-query';
import { fetchTeamMembers } from '~/api/team';

export const getListTeamMembersKey = () => {
  return 'team/list';
};

export const useTeamMembersQuery = (queryParams = {}) => {
  return useQuery({
    queryKey: getListTeamMembersKey(),
    queryFn: fetchTeamMembers,

    // Cache forever until the cache is cleared manually
    staleTime: Infinity,

    // No retries
    retry: false,

    // Allow overriding default react-query props
    ...queryParams
  });
};